// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
import { iconFilledClassName, iconRegularClassName } from "@fluentui/react-icons";
/**
 * Styles for PlanHeaderControls
 */ export const usePlanHeaderControlsStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        minWidth: "0",
        alignItems: "center",
        columnGap: tokens.spacingHorizontalSNudge
    },
    button: {
        minWidth: "auto",
        borderRadius: tokens.borderRadiusXLarge
    },
    diamondButton: {
        margin: "0px"
    },
    iconContainer: {
        marginRight: tokens.spacingHorizontalS,
        display: "flex",
        alignItems: "center",
        ":hover": {
            [`& .${iconFilledClassName}`]: {
                display: "block"
            },
            [`& .${iconRegularClassName}`]: {
                display: "none"
            }
        }
    }
});
